import { Flip, gsap } from './gsapSetup'

export type FlipState = ReturnType<typeof Flip.getState>

export function captureFlip(targets: Element[]): FlipState {
  return Flip.getState(targets)
}

/** Animate from a previously captured Flip state after the DOM has changed. */
export function runFlip(state: FlipState): void {
  Flip.from(state, {
    duration: 0.6,
    ease: 'power3.inOut',
    absolute: true,
    scale: true,
    stagger: 0.03,
    onEnter: (els) =>
      gsap.fromTo(els, { opacity: 0, scale: 0.85 }, { opacity: 1, scale: 1, duration: 0.45, ease: 'power2.out' }),
    onLeave: (els) => gsap.to(els, { opacity: 0, scale: 0.85, duration: 0.3, ease: 'power2.in' }),
  })
}
